/** SELECT ACTION */
export const ACTION_SET_LANGUAGE_ID = "ACTION_SET_LANGUAGE_ID"
export const ACTION_SET_LANG = "ACTION_SET_LANG"
export const ACTION_SET_LANG_SELECTED = "ACTION_SET_LANG_SELECTED"
export const ACTION_SET_ALERT_SUCCESS = "ACTION_SET_ALERT_SUCCESS"
export const ACTION_SET_ALERT_SUCCESS_TEXT = "ACTION_SET_ALERT_SUCCESS_TEXT"
export const ACTION_SET_ALERT_DANGER = "ACTION_SET_ALERT_DANGER"
export const ACTION_SET_ALERT_DANGER_TEXT = "ACTION_SET_ALERT_DANGER_TEXT"